/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Jade_Stork_LurkInputs */

const en_tall_jade_stork_lurk = /** @type {(inputs: Tall_Jade_Stork_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access rights import`)
};

const de_tall_jade_stork_lurk = /** @type {(inputs: Tall_Jade_Stork_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriffsrechte-Import`)
};

/**
* | output |
* | --- |
* | "Access rights import" |
*
* @param {Tall_Jade_Stork_LurkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_jade_stork_lurk = /** @type {((inputs?: Tall_Jade_Stork_LurkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Jade_Stork_LurkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_jade_stork_lurk(inputs)
	return de_tall_jade_stork_lurk(inputs)
});